import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../core/config/environment";
import { DivisionDto } from "../models/divisionDto";

@Injectable({
  providedIn: "root"
})
export class DivisionService {

  private readonly url = `${environment.backend.apiBaseURL}/api/admin/divisions`;

  private readonly getDivisionsForUserUrl =
    `${environment.backend.apiBaseURL}/api/user/getDivisionsForUser`;

  constructor(private http: HttpClient) { }

  getDivisions(): Observable<DivisionDto[]> {
    return this.http.get<DivisionDto[]>(this.url);
  }

  getDivisionsForUser(): Observable<DivisionDto[]> {
    return this.http.get<DivisionDto[]>(this.getDivisionsForUserUrl);
  }
}
